import { reactive, readonly } from 'vue'
import { forEach } from 'lodash'
import useProduct from '@/hooks/useProduct'

// Hooks
const { getCategoryIdFromProduct, getGroupIdFromProduct, getSelectedProductsOfPerson } = useProduct()

// Data
const conditions = reactive({
  language: undefined,
  content: undefined,
})

// Methods
function loadConditionsContent({ language }) {
  const hasConditions = !!conditions.content
  if (!hasConditions || conditions.language !== language) {
    import(`@/language/conditions/conditions.${language}.json`).then(content => {
      conditions.language = language
      conditions.content = content.default
      return conditions
    })
  }
}

function filterFileByProducts(condition, products) {
  const includesCategory = product => condition.categories?.includes(product.category)
  const includesGroup = product => condition.groups?.includes(product.group)
  const includesProduct = product => condition.products?.includes(product.product)
  const excludesProduct = product => condition.excludes?.includes(product.product)
  const hasNoCollective = product => !(condition.collective && product.collective)
  return products.some(product => {
    if (
      (!includesCategory(product) && !includesGroup(product) && !includesProduct(product)) ||
      excludesProduct(product)
    ) {
      return false
    }
    if (hasNoCollective(product)) return true
    const { collective } = product
    const { groups, contracts } = condition.collective
    const includesContractNumber = contracts?.includes(collective.contractNumber)
    if (!includesContractNumber) return false
    return groups ? groups?.includes(collective.personGroup) : true
  })
}

function getConditionProducts(persons, contractNumber) {
  const products = []

  persons.forEach(person => {
    let collective
    if (person.collectivePersonGroup) {
      collective = {
        contractNumber,
        personGroup: person.collectivePersonGroup,
      }
    }

    const selectedProducts = getSelectedProductsOfPerson(person.products.products)
    forEach(selectedProducts, product => {
      const { productId } = product
      products.push({
        category: getCategoryIdFromProduct(productId),
        group: getGroupIdFromProduct(productId),
        product: productId,
        collective,
      })
    })
  })
  return products
}

function getFilteredConditions(__conditions, persons, contractNumber) {
  if (!__conditions) {
    return []
  }
  const products = getConditionProducts(persons, contractNumber)
  return __conditions.filter(file => filterFileByProducts(file, products))
}

export default function useCondition() {
  return {
    conditions: readonly(conditions),
    getFilteredConditions,
    loadConditionsContent,
  }
}
